<div class="container-inicial">
  <div class="left">
    <div class="destaques">
      <div class="destaques-card">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <div class="destaque-card-img">
            <img [src]="corretor?.avatar" alt="Imagem" class="image-destaque">
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <h1 class="name-text">{{ corretor?.nome }}</h1>
      <h3 class="ocupation-text">{{ corretor?.cargo }}</h3>
      <h6 *ngIf="corretor?.creci.length > 0">CRECI: {{corretor?.creci}}</h6>
    </div>
  </div>


  <div class="right">
    <div class="botoes">
      <!-- Botão de WhatsApp -->
      <button class="botao ativo" (click)="openWhatsApp()">
        <i class="fab fa-whatsapp"></i> WhatsApp
      </button>
      <!-- Botão de E-mail -->
      <button class="botao email" (click)="openEmail()">
        <i class="fas fa-envelope"></i> E-mail
      </button>
      <!-- <button class="botao apresentacao"><i class="fas fa-file-alt"></i> Apresentação</button> -->
    </div>
  </div>
</div>

<!-- <div id="map"></div> -->

<div *ngIf="corretor?.bio" class="corretor-bio-container">
  <p class="corretor-bio-text" [class.expanded]="bioExpandida">
    {{ corretor?.bio }}
  </p>
  <button *ngIf="corretor?.bio?.length > 200" class="toggle-button" (click)="bioExpandida = !bioExpandida">
    {{ bioExpandida ? 'Ler menos' : 'Ler mais' }}
  </button>
</div>